
// @ts-nocheck
import locale_cs_46js_1d22a862 from "#nuxt-i18n/1d22a862";
import locale_ua_46js_c2840d87 from "#nuxt-i18n/c2840d87";

export const localeCodes =  [
  "cs",
  "ua"
]

export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46js_1d22a862",
      load: () => Promise.resolve(locale_cs_46js_1d22a862),
      cache: true
    }
  ],
  ua: [
    {
      key: "locale_ua_46js_c2840d87",
      load: () => Promise.resolve(locale_ua_46js_c2840d87),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/46c0cdef" /* webpackChunkName: "config_i18n_46config_46js_46c0cdef" */)
]

export const nuxtI18nOptions = {
  restructureDir: false,
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "cs",
      language: "cs",
      name: "Čeština",
      files: [
        {
          path: "/vercel/path0/locales/cs.js",
          cache: undefined
        }
      ]
    },
    {
      code: "ua",
      language: "ua",
      name: "Ukrajinština",
      files: [
        {
          path: "/vercel/path0/locales/ua.js",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "cs",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "cs",
    language: "cs",
    name: "Čeština",
    files: [
      {
        path: "/vercel/path0/locales/cs.js",
        cache: undefined
      }
    ]
  },
  {
    code: "ua",
    language: "ua",
    name: "Ukrajinština",
    files: [
      {
        path: "/vercel/path0/locales/ua.js",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/